"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcIsLastItem = void 0;
function calcIsLastItem(node, item) {
    var _a, _b;
    if (!((_b = (_a = node.itemCollection) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length))
        return false;
    const siblings = node.itemCollection.items;
    const noSiblings = siblings.length;
    return item === siblings[noSiblings - 1];
}
exports.calcIsLastItem = calcIsLastItem;
exports.default = calcIsLastItem;
